// @ts-nocheck
import React, { useCallback, useEffect, useState } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Button, Dropdown, Form, Grid, Input, Search, Segment } from 'semantic-ui-react';
import api from 'store/api';
const defaultAllowedNetworkIds = [
    '240',
    '85',
    '1',
    '517',
    '13', // Grønn Kontakt
];
const defaultPreferredNetworkIds = 240;
const defaultPreferredChargeCostMultiplier = 0.45;
const defaultNonPreferredChargeCostAddition = 800;
const defaultInitialSocPerc = 90;
const defaultArrivalSocPerc = 20;
const defaultFindAlternatives = true;
export function RoutePlanner() {
    var _a, _b, _c, _d;
    // Dropdown Options
    const [vehicleTypeOptions, vehicleTypeOptionsUpdater] = useState([]);
    const [searchSuggestionOptions, searchSuggestionOptionsUpdater] = useState();
    // Route Planner Params
    const [vehicleTypes, vehicleTypesUpdater] = useState();
    const [selectedVehicle, selectedVehicleUpdater] = useState();
    const [selectedVehicleDetails, selectedVehicleDetailsUpdater] = useState();
    const [allowedNetworksIds, allowedNetworkIdsUpdater] = useState(defaultAllowedNetworkIds);
    const [preferredNetworkIds, preferredNetworkIdsUpdater] = useState(defaultPreferredNetworkIds);
    const [initialSocPerc, initialSocPercUpdater] = useState(defaultInitialSocPerc);
    const [arrivalSocPerc, arrivalSocPercUpdater] = useState(defaultArrivalSocPerc);
    const [preferredChargeCostMultiplier, preferredChargeCostMultiplierUpdater] = useState(defaultPreferredChargeCostMultiplier);
    const [nonPreferredChargeCostAddition, nonPreferredChargeCostAdditionUpdater] = useState(defaultNonPreferredChargeCostAddition);
    const [findAlternatives, findAlternativesUpdater] = useState(defaultFindAlternatives);
    const [range, rangeUpdater] = useState(0);
    const [origin, originUpdater] = useState('');
    const [destination, destinationUpdater] = useState('');
    const [originCoordinates, originCoordinatesUpdater] = useState();
    const [destinationCoordinates, destinationCoordinatesUpdater] = useState();
    // Loaders
    const [originLoader, originLoaderUpdater] = useState(false);
    const [destinationLoader, destinationLoaderUpdater] = useState(false);
    const [routePlannerLoader, routePlannerLoaderUpdater] = useState(false);
    // Route Results
    const [routes, routesUpdater] = useState();
    useEffect(() => {
        // Do initial get calls
        api.get('/_api/vehicle-types').then((response) => {
            const dropdownOptions = response.data.map((vehicle) => {
                return {
                    key: vehicle.id,
                    value: vehicle.id,
                    text: `${vehicle.brand} ${vehicle.model} ${vehicle.version}`,
                };
            });
            vehicleTypeOptionsUpdater(dropdownOptions);
            vehicleTypesUpdater(response.data);
        }, 
        // eslint-disable-next-line no-console
        () => console.log('Get Vehicle Types Error'));
    }, []);
    useEffect(() => {
        var _a, _b;
        if (selectedVehicle) {
            const vehicleDetails = vehicleTypes === null || vehicleTypes === void 0 ? void 0 : vehicleTypes.find((vehicle) => vehicle.id === selectedVehicle);
            selectedVehicleDetailsUpdater(vehicleDetails);
            const rangeValue = Math.round(+((_a = vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.externalParameters) === null || _a === void 0 ? void 0 : _a.usable_battery_wh) /
                +((_b = vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.externalParameters) === null || _b === void 0 ? void 0 : _b.ref_consumption));
            rangeUpdater(rangeValue);
        }
    }, [selectedVehicle, vehicleTypes]);
    const getSuggestions = useCallback(async (value) => {
        api.get(`/_api/search-suggestions`, { params: { keyword: value } }).then((response) => {
            var _a;
            const dropdownOptions = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.map((place) => {
                return {
                    title: place.description,
                    id: place.place_id,
                };
            });
            searchSuggestionOptionsUpdater(dropdownOptions);
            originLoaderUpdater(false);
            destinationLoaderUpdater(false);
        }, 
        // eslint-disable-next-line no-console
        () => console.log('Get Suggestions Error'));
    }, []);
    const getLocationDetails = useCallback(async (value, searchType) => {
        api.get(`/_api/location-details`, { params: { id: value } }).then((response) => {
            var _a, _b, _c;
            const coordinates = (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.geometry) === null || _c === void 0 ? void 0 : _c.location;
            if (searchType === 'origin') {
                originCoordinatesUpdater(coordinates);
            }
            else if (searchType === 'destination') {
                destinationCoordinatesUpdater(coordinates);
            }
        }, 
        // eslint-disable-next-line no-console
        () => console.log('Get Suggestions Error'));
    }, []);
    const searchResultRenderer = ({ title, description }) => React.createElement("div", { key: description }, title);
    const searchChangeHandler = (query) => {
        if (query) {
            getSuggestions(query);
        }
        else {
            originLoaderUpdater(false);
            destinationLoaderUpdater(false);
        }
    };
    const planRoute = async () => {
        var _a, _b, _c;
        routePlannerLoaderUpdater(true);
        const consumption = +((_a = selectedVehicleDetails === null || selectedVehicleDetails === void 0 ? void 0 : selectedVehicleDetails.externalParameters) === null || _a === void 0 ? void 0 : _a.usable_battery_wh) / +range;
        const destinations = [
            { address: origin, lat: originCoordinates.lat, lon: originCoordinates.lng },
            { address: destination, lat: destinationCoordinates.lat, lon: destinationCoordinates.lng },
        ];
        api
            .get(`/_api/plan`, {
            params: {
                car_model: (_b = selectedVehicleDetails === null || selectedVehicleDetails === void 0 ? void 0 : selectedVehicleDetails.externalParameters) === null || _b === void 0 ? void 0 : _b.typecode,
                fast_chargers: (_c = selectedVehicleDetails === null || selectedVehicleDetails === void 0 ? void 0 : selectedVehicleDetails.externalParameters) === null || _c === void 0 ? void 0 : _c.fast_chargers,
                preferred_charge_cost_multiplier: preferredChargeCostMultiplier > 0 ? preferredChargeCostMultiplier : undefined,
                nonpreferred_charge_cost_addition: nonPreferredChargeCostAddition > 0 ? nonPreferredChargeCostAddition : undefined,
                allowed_network_ids: allowedNetworksIds.toString(),
                preferred_network_ids: preferredNetworkIds,
                ref_consumption: consumption,
                initial_soc_perc: initialSocPerc,
                arrival_soc_perc: arrivalSocPerc,
                find_alts: findAlternatives,
                destinations: JSON.stringify(destinations),
            },
        })
            .then((response) => {
            routesUpdater(response.data.body);
            routePlannerLoaderUpdater(false);
        }, 
        // eslint-disable-next-line no-console
        () => console.log('Get Suggestions Error'));
    };
    const onResultSelectHandler = (data, searchType) => {
        const selection = data.result;
        getLocationDetails(selection.id, searchType);
        if (searchType === 'origin') {
            originUpdater(selection.title);
        }
        else if (searchType === 'destination') {
            destinationUpdater(selection.title);
        }
    };
    const onSearchChangedHandler = (data, searchType) => {
        const query = data.value;
        searchChangeHandler(query);
        if (searchType === 'origin') {
            originLoaderUpdater(true);
            originUpdater(query);
        }
        else if (searchType === 'destination') {
            destinationLoaderUpdater(true);
            destinationUpdater(query);
        }
    };
    const durationFormatter = (duration) => {
        const durationString = Math.round(duration / 60);
        if (durationString < 60) {
            return `${durationString} min`;
        }
        else {
            const hours = Math.floor(durationString / 60);
            const minutes = durationString % 60;
            return `${hours} hr ${minutes} min`;
        }
    };
    const isFormValid = useCallback(() => {
        if (!selectedVehicleDetails ||
            !originCoordinates ||
            !destinationCoordinates ||
            !initialSocPerc ||
            !arrivalSocPerc) {
            return false;
        }
        else {
            return true;
        }
    }, [selectedVehicleDetails, originCoordinates, destinationCoordinates, initialSocPerc, arrivalSocPerc]);
    return (React.createElement(Grid, { style: { padding: 40, width: 1360, margin: '0 auto' } },
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: 8 },
                React.createElement(Segment, { style: { minHeight: '100%', background: 'white' }, placeholder: true, loading: routePlannerLoader },
                    (routes === null || routes === void 0 ? void 0 : routes.result) && (routes === null || routes === void 0 ? void 0 : routes.status) !== 'ok' && (React.createElement("h5", { style: { color: 'red', textAlign: 'center' } },
                        "Error: ", routes === null || routes === void 0 ? void 0 :
                        routes.status)),
                    !routes && React.createElement("h5", { style: { textAlign: 'center' } }, "Search a route first"), (_b = (_a = routes === null || routes === void 0 ? void 0 : routes.result) === null || _a === void 0 ? void 0 : _a.routes) === null || _b === void 0 ? void 0 :
                    _b.map((route, index) => {
                        var _a;
                        return (
                        // eslint-disable-next-line react/no-array-index-key
                        React.createElement(Segment.Group, { key: index },
                            React.createElement(Segment.Group, { horizontal: true },
                                React.createElement(Segment, { style: { width: '40%', display: 'flex', alignItems: 'center' } },
                                    React.createElement("h3", null,
                                        "Route ",
                                        index + 1)),
                                React.createElement(Segment, { style: { width: '20%' } },
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Duration"),
                                        " ",
                                        React.createElement("br", null),
                                        durationFormatter(route.total_drive_duration + route.total_charge_duration))),
                                React.createElement(Segment, { style: { width: '20%' } },
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Distance"),
                                        " ",
                                        React.createElement("br", null),
                                        Math.round(route.total_dist / 1000),
                                        " km"))), (_a = route === null || route === void 0 ? void 0 : route.steps) === null || _a === void 0 ? void 0 :
                            _a.map((step) => step.is_charger && (React.createElement(Segment.Group, { horizontal: true, style: { background: step.name.includes('Fastned') ? 'rgba(253,219,47,.1)' : '' } },
                                React.createElement(Segment, { style: { width: '40%', display: 'flex', alignItems: 'center' } },
                                    React.createElement("div", { style: { display: 'flex', alignItems: 'center', flexDirection: 'row-reverse' } },
                                        React.createElement("span", null, step.name),
                                        step.name.includes('Fastned') && (React.createElement("img", { src: "https://cdn.fastnedcharging.com/media/images/fastned-app-icon-300x300.png", style: {
                                                width: 20,
                                                height: 20,
                                                float: 'left',
                                                marginRight: 5,
                                                borderRadius: 100,
                                            } })))),
                                React.createElement(Segment, { style: { width: '20%' } },
                                    React.createElement("b", null, "Arrival"),
                                    React.createElement("br", null),
                                    " ",
                                    step.arrival_perc,
                                    "%"),
                                React.createElement(Segment, { style: { width: '20%' } },
                                    React.createElement("b", null, "Charge Until"),
                                    React.createElement("br", null),
                                    step.departure_perc,
                                    "%"))))));
                    }))),
            React.createElement(Grid.Column, { width: 8 },
                React.createElement(Segment, { loading: routePlannerLoader },
                    React.createElement(Form, null,
                        React.createElement(Form.Field, null,
                            React.createElement("label", null, "Select Vehicle"),
                            React.createElement(Dropdown, { label: "Select Vehicle", placeholder: "Select Vehicle", fluid: true, selection: true, search: true, loading: !vehicleTypeOptions.length, options: vehicleTypeOptions, onChange: (e, { value }) => {
                                    selectedVehicleUpdater(value);
                                } })),
                        React.createElement(Form.Field, { required: true },
                            React.createElement("label", null, "Origin"),
                            React.createElement(Search, { minCharacters: 2, fluid: true, loading: originLoader, onResultSelect: (_, data) => onResultSelectHandler(data, 'origin'), onSearchChange: (_, data) => onSearchChangedHandler(data, 'origin'), results: searchSuggestionOptions, resultRenderer: searchResultRenderer, value: origin })),
                        React.createElement(Form.Field, { required: true },
                            React.createElement("label", null, "Destination"),
                            React.createElement(Search, { minCharacters: 2, fluid: true, loading: destinationLoader, onResultSelect: (_, data) => onResultSelectHandler(data, 'destination'), onSearchChange: (_, data) => onSearchChangedHandler(data, 'destination'), results: searchSuggestionOptions, resultRenderer: searchResultRenderer, value: destination })),
                        React.createElement(Form.Group, { widths: "equal" },
                            React.createElement(Form.Field, { error: !initialSocPerc, required: true },
                                React.createElement("label", null, "Initial Soc Perc"),
                                React.createElement(Input, { value: initialSocPerc, label: { basic: true, content: '%' }, labelPosition: "right", onChange: (e, { name, value }) => initialSocPercUpdater(value) })),
                            React.createElement(Form.Field, { error: !arrivalSocPerc, required: true },
                                React.createElement("label", null, "Arrival Soc Perc"),
                                React.createElement(Input, { value: arrivalSocPerc, label: { basic: true, content: '%' }, labelPosition: "right", onChange: (e, { name, value }) => arrivalSocPercUpdater(value) }))),
                        React.createElement(Form.Group, { widths: "equal" },
                            React.createElement(Form.Field, { error: !range, required: true },
                                React.createElement("label", null, "Range"),
                                React.createElement(Input, { value: range, onChange: (e, { name, value }) => value && rangeUpdater(value) })),
                            React.createElement(Form.Field, null,
                                React.createElement("label", null, "Charge Cost"),
                                React.createElement(Input, { value: preferredChargeCostMultiplier, onChange: (e, { name, value }) => preferredChargeCostMultiplierUpdater(value) })),
                            React.createElement(Form.Field, null,
                                React.createElement("label", null, "Nonpreferred Charge Cost"),
                                React.createElement(Input, { value: nonPreferredChargeCostAddition, onChange: (e, { name, value }) => nonPreferredChargeCostAdditionUpdater(value) }))),
                        React.createElement(Form.Group, { widths: "equal" },
                            React.createElement(Form.Field, null,
                                React.createElement("label", null, "Ref Consumption"),
                                ((_c = selectedVehicleDetails === null || selectedVehicleDetails === void 0 ? void 0 : selectedVehicleDetails.externalParameters) === null || _c === void 0 ? void 0 : _c.ref_consumption) || 0),
                            React.createElement(Form.Field, null,
                                React.createElement("label", null, "Fast Chargers"),
                                ((_d = selectedVehicleDetails === null || selectedVehicleDetails === void 0 ? void 0 : selectedVehicleDetails.externalParameters) === null || _d === void 0 ? void 0 : _d.fast_chargers) || 'none')),
                        React.createElement(Form.Group, { widths: "equal" },
                            React.createElement(Form.Field, null,
                                React.createElement("label", null, "Allowed Network Ids"),
                                React.createElement(Input, { value: allowedNetworksIds.toString(), onChange: (e, { name, value }) => allowedNetworkIdsUpdater(value) })),
                            React.createElement(Form.Field, null,
                                React.createElement("label", null, "Prefered Network Ids"),
                                React.createElement(Input, { value: preferredNetworkIds, onChange: (e, { name, value }) => preferredNetworkIdsUpdater(value) }))),
                        React.createElement(Form.Checkbox, { label: "Find Alternatives", checked: findAlternatives, onChange: () => findAlternativesUpdater(!findAlternatives) }),
                        React.createElement(Grid, null,
                            React.createElement(Grid.Column, { width: 8, textAlign: "left" }),
                            React.createElement(Grid.Column, { width: 8, textAlign: "right" },
                                React.createElement(Button, { icon: "location arrow", content: "Plan Route", onClick: planRoute, disabled: !isFormValid(), style: { background: !isFormValid() ? 'lightgrey' : '#FDDC2E' } })))))))));
}
